export const FINANCE_CELL_EMPTY_PLACEHOLDER = 'N/A' as const;
export type IFinanceCellEmptyPlaceholder = typeof FINANCE_CELL_EMPTY_PLACEHOLDER;
